<app-dialog-header title="Shift Details" (closeClicked)="onCancelClick()">
</app-dialog-header>

<mat-dialog-content class="fullscreen-dialog">
  <ngx-ui-loader [loaderId]="'zoneEditLoader'"></ngx-ui-loader>

  @if (loaded) {
  <form [formGroup]="shiftEditorForm">
    <div class="form-main">
      <div class="two-column-layout">
        <!-- Column A: Day, Division, Start/End Time -->
        <div class="column">
          <!-- Day select -->
          <div class="form-row">
            <mat-form-field class="form-field" appearance="fill">
              <mat-label>Day</mat-label>
              <mat-select formControlName="selectedDay" (selectionChange)="handleDayChange($event)">
                @for (day of days; track day.value) {
                <mat-option [value]="day.value">{{ day.display }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>

          <!-- Division select -->
          <div class="form-row">
            <mat-form-field class="form-field" appearance="fill">
              <mat-label>Division</mat-label>
              <mat-select formControlName="selectedDivision" required [compareWith]="compareDivisions" (selectionChange)="handleDivisionChange($event)">
                @for (division of divisions; track division.id) {
                <mat-option [value]="division">{{ division.name }}</mat-option>
                }
              </mat-select>
              <mat-error>Please choose a division</mat-error>
            </mat-form-field>
          </div>

          <!-- Start/End Time -->
          <div class="form-row">
            <mat-form-field appearance="fill" style="width:48%">
              <mat-label>Start</mat-label>
              <input (change)="startTimeChanged($event)" formControlName="startTime" matInput type="time"
                aria-label="Start time">
            </mat-form-field>
            <mat-form-field appearance="fill" style="width:48%; margin-left: 4%">
              <mat-label>End</mat-label>
              <input formControlName="endTime" matInput type="time" aria-label="End time">
            </mat-form-field>
          </div>
        </div>

        <!-- Column B: Reservation Sliders -->
        <div class="column">
          <label for="cyclical-slider">Auto-Book Reservation</label>
          <mat-slider class="reservation-slider" [discrete]="true" [displayWith]="formatLabel">
            <input matSliderThumb id="cyclical-slider" [value]="cyclicalPriorityReservationPercent"
              (valueChange)="onSliderChange('cyclical', $event)" [min]="0" [max]="100" [step]="1">
          </mat-slider>

          <label for="normal-slider">Normal Reservation</label>
          <mat-slider class="reservation-slider" [discrete]="true" [displayWith]="formatLabel">
            <input matSliderThumb id="normal-slider" [value]="normalPriorityReservationPercent"
              (valueChange)="onSliderChange('normal', $event)" [min]="0" [max]="100" [step]="1">
          </mat-slider>

          <label for="high-slider">High Reservation</label>
          <mat-slider class="reservation-slider" [discrete]="true" [displayWith]="formatLabel">
            <input matSliderThumb id="high-slider" [value]="highPriorityReservationPercent"
              (valueChange)="onSliderChange('high', $event)" [min]="0" [max]="100" [step]="1">
          </mat-slider>

          <label for="emergency-slider">Emergency Reservation</label>
          <mat-slider discrete class="reservation-slider" [discrete]="true" [displayWith]="formatLabel">
            <input matSliderThumb id="emergency-slider" [value]="emergencyPriorityReservationPercent"
              (valueChange)="onSliderChange('emergency', $event)" [min]="0" [max]="100" [step]="1">
          </mat-slider>
        </div>
      </div>

      <!-- Full Width Area: Timesheet Inputs -->
      @if (timesheetCodeMode) {
      <div class="full-width timesheet-section">
        <div class="row-display">
          <app-timesheet-code-chooser (codeChanged)="handleTravelCodeChange($event)" [selectedCode]="selectedTravelCode"
            [timesheetCodes]="timesheetCodes" displayAs="Travel" />
          <app-timesheet-code-chooser (codeChanged)="handleWorkCodeChange($event)" [selectedCode]="selectedWorkCode"
            [timesheetCodes]="timesheetCodes" displayAs="Work" />
          <mat-form-field appearance="fill" style="width:113px;">
            <mat-label>Overtime From</mat-label>
            <input (change)="overTimeChanged($event)" formControlName="overTime" matInput type="time"
              aria-label="Overtime from">
          </mat-form-field>
          <app-timesheet-code-chooser (codeChanged)="handleOverCodeChange($event)" [selectedCode]="selectedOverCode"
            [timesheetCodes]="timesheetCodes" displayAs="Over" />
        </div>
      </div>
      }
    </div>
  </form>
  }
</mat-dialog-content>
<mat-dialog-actions align="start">
  <button (click)="onDeleteClick()" color="warn" mat-flat-button>{{ 'scheduler.general.delete' | translate }}
    Shift</button>
  <span class="spacer"></span>
  <button (click)="resetForm()" mat-flat-button type="reset">{{ 'scheduler.general.undo' | translate }}</button>
  <button (click)="save()" [disabled]="shiftEditorForm.pristine || shiftEditorForm.invalid" color="primary"
    mat-raised-button type="submit">Save</button>
</mat-dialog-actions>